import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employer-overview',
  templateUrl: './employer-overview.component.html',
  styleUrls: ['./employer-overview.component.css']
})
export class EmployerOverviewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
